import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UI, DISPLAY, h2, SECTION_GAP } from '../../styles/tl5';
import { useGetPageSectionsQuery } from '../../store/siteContentApi';

// "How it works" — three cards, each led by its own elapsed time rather
// than a step number. The reference has no section link and no numbering;
// the times are the numbering.
// Fallback — mirrors DEFAULTS.home.how_it_works in pageSectionController.
const STEPS = [
  {
    time: '1 min',
    t: 'Book online or on WhatsApp',
    s: 'Pick tests, a package, or upload your prescription.',
  },
  {
    time: '60 min',
    t: 'A Trustian comes to you',
    s: 'Verified, trained, and trackable live.',
  },
  {
    time: '~6 hrs',
    t: 'Doctor-verified report',
    s: 'On WhatsApp, with a free doctor call if anything is flagged.',
  },
];

const HowItWorksV5 = () => {
  const { data: sections } = useGetPageSectionsQuery('home');
  const c = sections?.how_it_works || {};
  const steps = c.steps?.length ? c.steps : STEPS;
  const heading = c.heading || 'How it works';

  return (
  <Box
    component="section"
    sx={{
      width: '100%',
      maxWidth: 1320,
      mx: 'auto',
      pt: SECTION_GAP,
      px: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 2.5,
    }}
  >
    <Typography component="h2" sx={{ ...h2, px: 1 }}>{heading}</Typography>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
        gap: 1.5,
      }}
    >
      {steps.map((s) => (
        <Box
          key={s.time}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minWidth: 0,
            p: 'clamp(20px, 3.4vw, 32px)',
            borderRadius: '28px',
            bgcolor: '#FFFFFF',
          }}
        >
          <Box
            component="span"
            sx={{
              fontFamily: DISPLAY,
              fontWeight: 700,
              fontSize: 52,
              lineHeight: 1,
              color: 'var(--tl-teal)',
            }}
          >
            {s.time}
          </Box>
          <Box component="span" sx={{ fontFamily: UI, fontSize: 18, fontWeight: 800 }}>
            {s.t}
          </Box>
          <Box component="span" sx={{ fontFamily: UI, fontSize: 15, lineHeight: 1.55, color: 'var(--tl-muted-2)' }}>
            {s.s}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
  );
};

export default HowItWorksV5;
